import { NgModule } from 'ng-metadata/core';
import { TrackOrderComponent } from './track-order.component';

@NgModule({
  declarations: [
    TrackOrderComponent,
  ],
})
export class TrackOrderModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/components/track-order/track-order.module.ts